import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Input } from 'antd';
import { theme } from 'utils/style/theme';

/**
 * * 기본 인풋
 */

interface IProps {
  id?: string;
  name?: string;
  codeName?: string;
  defaultValue?: string;
  disabled?: boolean;
  lang?: string;
  localizing?: boolean; // 언어명이 적혀야 할 때 쓰인다.
  placeholder?: string;
  maxLength?: number;
  type?: string;
  status?: 'error' | 'warning';
  pattern?: string;
  width?: string;
  minLength?: number;
  key?: string | number;
  style?: React.CSSProperties;
  subText?: string;
  top?: string | boolean; // 인풋 하단에 또 인풋이 있으면 마진을 주고, 없으면 마진을 안준다.
  bottom?: string | boolean; // 하단에 더 이상 인풋(컴포넌트)가 없으니, 마진 주지마!
  marginBottom?: string;
  noMarginBottom?: boolean; // 하단에 더 이상 인풋(컴포넌트)가 없으니, 마진 주지마!
  title?: string;
  value?: string | number | undefined;
  ref?: React.Ref<HTMLDivElement> | React.Ref<HTMLInputElement> | undefined;
  warningText?: string;
  onChange?: (e: { target: HTMLInputElement }) => void;
  onClick?: (e?: any) => void;
  onBlur?: (e?: any) => void;
  allowClear?: boolean;
  styleInputWrapper?: React.CSSProperties;
}
const DefaultInput = forwardRef(
  (
    {
      id,
      name,
      defaultValue,
      value,
      onChange,
      placeholder,
      maxLength,
      disabled,
      style,
      type,
      pattern,
      onClick,
      onBlur,
      minLength,
      width,
      localizing,
      top,
      title,
      codeName,
      lang,
      subText,
      warningText,
      status,
      bottom,
      marginBottom,
      noMarginBottom,
      allowClear = false,
    }: IProps,
    ref,
  ) => {
    return (
      <InputWrap
        bottom={bottom}
        localizing={localizing}
        title={title}
        style={style}
        status={status}
        noMarginBottom={noMarginBottom}
      >
        <label htmlFor={id}>{title}</label>
        <div className='localizing_wrap'>
          <p className='localizing_name'>{codeName}</p>
          <InputStyled
            id={id}
            lang={lang}
            value={value}
            name={name}
            status={status}
            onChange={onChange}
            defaultValue={defaultValue}
            placeholder={placeholder}
            maxLength={maxLength}
            showCount={maxLength ? true : false} // maxLength가 있으면 글자 수도 보여준다
            allowClear={type || allowClear ? false : true}
            disabled={disabled}
            style={style}
            type={type} // number가 넘어온다.
            pattern={pattern}
            onClick={onClick}
            minLength={minLength}
            width={width}
            top={top}
            bottom={bottom}
            ref={ref}
            onBlur={onBlur}
          />
          {subText && <span className='sub_text'>{subText}</span>}
        </div>
        {status === 'error' && <p className='warning_text'>{warningText}</p>}
      </InputWrap>
    );
  },
);
export default DefaultInput;
const InputWrap = styled.div`
  width: 100%;
  & > * + * {
    margin-top: ${(props) => (props.title ? '8px' : '0')};
  }
  margin-bottom: ${(props) => (props.noMarginBottom ? '0' : '1.2rem')};
  label {
    display: ${(props) => (props.title ? 'block' : 'none')};
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.normal};
    margin-left: 0.3rem;
    /* margin-bottom: 0.2rem; */
  }
  .localizing_wrap {
    height: 2.8rem;
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
    .localizing_name {
      /* display: flex; */
      display: ${(props) => (props.localizing ? 'flex' : 'none')};
      align-items: center;
      justify-content: center;
      /* width: 4.8rem; */
      width: 18%;
      /* width: max-content; */
      height: 2.8rem;
      border: 1px solid ${theme.colors.gray_5};
      border-radius: 0.4rem;
      font-size: 1rem;
      font-weight: 600;
      color: ${theme.colors.blue_7};
      margin-right: 0.5rem;
    }
    .sub_text {
      display: block;
      margin-left: 0.5rem;
      margin-right: 1rem;
    }
  }
  .warning_text {
    display: ${(props) => (props.status !== 'error' ? 'none' : 'block')};
    color: red;
  }
`;
const InputStyled = styled(Input)<IProps>`
  background-color: #fff;
  border: 1px solid ${theme.colors.gray_5};
  border-radius: 0.4rem;
  /* margin-left: 0.5rem; */
  text-align: ${(props) => (props.type ? 'right' : 'left')};
  .ant-input {
    background-color: #fff;
    /* font-size: 1rem; */
  }
  .ant-input-show-count-suffix {
    font-size: 0.8rem;
    letter-spacing: -0.05rem;
  }
  &:hover {
    background-color: #fff;
  }
`;
